import { ArrowLeft } from "../../assets/icons";
import { NavLink } from "react-router-dom";

const NavBarMission = ({ user, isWaiting }) => {
  return (
    <nav className={"w-full flex justify-between items-center"}>
      <div className={"flex gap-4 items-center"}>
        <NavLink
          to={"/app/parameters/hourly-tracking"}
          className={"p-3 border rounded-full"}
        >
          <ArrowLeft wh={24} color={"#374151"} />
        </NavLink>
        <div className={"flex flex-col"}>
          <div className={"text-2xl font-bold capitalize"}>
            {isWaiting ? (
              <div className={"h-6 bg-gray-200 rounded w-40"}></div>
            ) : (
              `${user?.firstname && user?.lastname ? `${user?.firstname} ${user?.lastname}` : "Non défini"}`
            )}
          </div>
          <div className={"text-gray-500 text-sm"}>
            {isWaiting ? (
              <div className={"h-4 bg-gray-200 rounded w-20 mt-2"}></div>
            ) : (
              (() => {
                const matricules = Array.isArray(user?.matricules)
                  ? user.matricules
                  : user?.peopulseId
                    ? [{ source: "peopulse", value: user.peopulseId }]
                    : [];
                if (matricules.length === 0) return "Matricule : Non défini";
                return matricules
                  .map((m) => {
                    const value = m.value || m.externalId;
                    const sourceLabel =
                      m.source === "peopulse"
                        ? "Peopulse"
                        : m.source === "jobbiz"
                          ? "Jobbiz"
                          : m.source === "workfully"
                            ? "Workfully"
                            : (m.source || "").charAt(0).toUpperCase() +
                              (m.source || "").slice(1);
                    return `${sourceLabel} : ${value}`;
                  })
                  .join(" • ");
              })()
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBarMission;
